<template>
    <v-btn x-large class="w-100 px-16 px-lg-20 justify-space-between" rounded elevation="0" @click="toggleSchedule" color="grey-light">
        <span class="grey-dark--text"> {{ time }}시 </span>
        <v-simple-checkbox :value="isChecked" v-bind="{ disabled }" hide-details color="primary" class="d-block" />
    </v-btn>
    <!-- <v-simple-checkbox :value="isChecked" v-bind="{ disabled }" hide-details color="primary" class="d-block" /> -->
</template>

<script>
export default {
    props: {
        schedules: { type: Array, default: () => [] },
        subject: { type: Object, default: () => ({}) },
        date: { type: String },
        time: { type: Number },
        limitationMet: { type: Boolean, default: false },
    },
    computed: {
        schedule() {
            const { date, time } = this;
            return { _subject: this.subject?._id, date, time };
        },
        isChecked() {
            let { _subject, date, time } = this.schedule;
            return this.schedules.some((subject) => subject._subject == _subject && subject.date == date && subject.time == time);
        },
        disabled() {
            return !this.isChecked && this.limitationMet;
        },
    },
    methods: {
        toggleSchedule() {
            if (this.isChecked) this.$emit("del", this.schedule);
            else if (this.limitationMet) alert("한 주 동안 3시간을 초과해 대여할 수 없습니다");
            else this.$emit("add", this.schedule);
        },
    },
};
</script>

<style scoped></style>
